import {faker} from '@faker-js/faker';
import {usersList} from "./users";

export const generateFakeActivityLogs = (count = 500) => {

    return Array.from({length: count}).map((_, i) => {
        const date = faker.date.recent({days: 10});
        const user  = faker.helpers.arrayElement(usersList);
        return {
            id: `LOG-${String(i + 1).padStart(4, "0")}`,
            date: date.toISOString(),
            timestamp: date.getTime(),
            userId: faker.number.int({min: 1, max: 10}),
            userName: user.memberName,
            role: user.role,
            action: faker.helpers.arrayElement(["login","logout","alert_closed","alert_reviewed",
                "rule_created",
                "rule_edited",
                "rule_deleted",
                "setting_changed",
                "alert_closed"]),
            details: faker.lorem.sentence()
        }


    });
};
